import { useEffect, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { Container } from 'react-bootstrap'
import { t } from '../locale'

export default function BexioCallback() {
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    const code = searchParams.get('code')
    const state = searchParams.get('state')
    const oauthError = searchParams.get('error')
    const errorDescription = searchParams.get('error_description')

    if (oauthError) {
      setError(errorDescription ?? oauthError)
      return
    }

    if (!code || !state) {
      setError('Missing code or state from Bexio.')
      return
    }

    fetch(`${process.env.REACT_APP_API_URL}/bexio/exchange`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ code, state }),
    })
      .then(res => res.json())
      .then(data => {
        if (data.ok) {
          navigate('/company/bexio?bexio=connected', { replace: true })
        } else {
          setError(data.message?.content ?? t('bexioConnectionFailed'))
        }
      })
      .catch(() => setError(t('bexioConnectionFailed')))
  }, [])

  if (error) {
    return (
      <Container className='mt-5 text-center'>
        <p className='text-danger'>{error}</p>
      </Container>
    )
  }

  return (
    <Container className='mt-5 text-center'>
      <p className='text-muted'>{t('bexioConnecting')}</p>
    </Container>
  )
}
